
export enum Role {
  ADMIN = 'ADMIN',
  USER = 'USER',
  KIOSK = 'KIOSK'
}

export interface UserShiftConfig {
    start: string; // "HH:mm"
    end: string;   // "HH:mm"
    isSaturdayWorkDay: boolean;
    saturdayStart?: string;
    saturdayEnd?: string;
}

export interface User {
  id: string;
  username: string;
  fullName: string;
  password: string; // In a real app, this would be hashed
  role: Role;
  department: string;
  employmentStartDate?: string; // YYYY-MM-DD
  salary?: string;
  isActive: boolean;
  shiftConfig?: UserShiftConfig; // Personal Shift Config
  isFixedSalary?: boolean; // If true, ignore overtime/deductions calculation for salary
  isExcludedFromSalary?: boolean; // NEW: If true, user is hidden from salary calculations and payroll
}

export enum LogType {
  ENTRY = 'GİRİŞ',
  EXIT = 'ÇIKIŞ'
}

export interface AttendanceLog {
  id: string;
  userId: string;
  userFullName: string;
  timestamp: number; // Unix timestamp
  type: LogType;
  ip?: string;       
  userAgent?: string; 
}

export interface AppConfig {
  qrSecret: string; 
  qrRefreshSeconds: number;
  companyName: string;
  logoUrl?: string; // Base64 or URL
  shiftStart: string; // Global Default Start
  shiftEnd: string;   // Global Default End
  isSaturdayWorkDay: boolean; // Global Default
  saturdayStart?: string; 
  saturdayEnd?: string;   
  publicHolidays: string[]; 
  departments: string[]; // List of department names
  lastAutoBackupDate?: string; // YYYY-MM-DD
}

export interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
}

export enum LeaveType {
    ANNUAL = 'YILLIK İZİN',
    SICK = 'RAPORLU',
    UNPAID = 'ÜCRETSİZ İZİN',
    CASUAL = 'MAZERET İZNİ',
    OTHER = 'DİĞER'
}

export interface LeaveRecord {
    id: string;
    userId: string;
    userFullName: string;
    startDate: string; // YYYY-MM-DD
    endDate: string;   // YYYY-MM-DD
    type: LeaveType;
    description?: string;
    daysDeducted: number; 
    createdAt: number;
}

export interface CloudBackup {
    id: string; 
    date: string; 
    timestamp: number; 
    data?: string; // Old format support (keep optional)
    size: string; 
    creator: string;
    // New Fields for Chunking
    totalChunks?: number;
    version?: string;
    status?: 'COMPLETE' | 'PARTIAL';
}

// --- NOTIFICATIONS / REQUESTS ---
export enum NotificationType {
    FORGOT_QR = 'QR OKUTMAYI UNUTTUM',
    QR_FAILED = 'QR OKUTAMADIM (HATA)',
    CORRECTION = 'DÜZELTME TALEBİ',
    OTHER = 'DİĞER'
}

export enum NotificationStatus {
    PENDING = 'BEKLEMEDE',
    APPROVED = 'ONAYLANDI',
    REJECTED = 'REDDEDİLDİ'
}

export interface Notification {
    id: string;
    userId: string;
    userFullName: string;
    type: NotificationType;
    status: NotificationStatus;
    description: string;
    targetDate: string; // YYYY-MM-DD relates to the event
    targetTime?: string; // HH:mm
    createdAt: number;
}

// --- SALARY / PAYROLL ---
export interface SalaryRecord {
    id: string;         // Composite: userId_YYYY-MM
    userId: string;
    userFullName: string;
    month: string;      // YYYY-MM
    
    baseSalary: number;      // Maaş (TL)
    hourlyRate: number;      // Saatlik Ücret (TL)
    
    overtimeHours: number;   // 1.5x Mesai Saati (Dakika cinsinden tutulup saate çevrilir)
    overtimePay: number;     // 1.5x Mesai Tutarı (TL)
    
    holidayHours: number;    // 2x Mesai Saati (Dakika cinsinden)
    holidayPay: number;      // 2x Mesai Tutarı (TL)
    
    missingHours: number;    // Eksik Saat (Dakika cinsinden) - Geç kalma, erken çıkış
    missingPay: number;      // Saatlik Kesinti Tutarı (TL)
    
    missingDays: number;     // Eksik Gün Sayısı (Gelmediği gün)
    missingDaysPay: number;  // Günlük Kesinti Tutarı (TL)
    
    extra: number;           // Ekstra / Bonus / Prim (TL) - Manuel
    
    totalPay: number;        // Hakediş (TL)
    bankPay: number;         // Bankadan Ödenen (TL)
    cashPay: number;         // Elden Ödenen (TL)
    
    updatedAt: number;
}
